<template>
	<div>
		<!-- Cabecera -->
		<pm-header>
			<template slot="contenido">
				<div class="row h-100 d-flex align-items-center fondo-header m-0">
					<div
						class="col-12 col-sm-10 offset-sm-1 col-lg-4 offset-lg-1 col-xl-5 offset-xl-2 text-center text-lg-left text-white"
						data-aos="fade-right"
						data-aos-delay="750"
					>
						<p class="fuente-header-titulo p-0 m-0">Cualquier duda</p>
						<p class="fuente-header-subtitulo p-0 m-0">¡la aclaramos!</p>
					</div>
					<div class="col-lg-6 col-xl-3 d-none d-lg-block" data-aos="fade-left" data-aos-delay="250">
						<img class="img-fluid" src="@/assets/img-pub/Difarmer-preguntas-frecuentes.png" />
					</div>
				</div>
			</template> 
		</pm-header>

		<!-- Preguntas -->
		<div class="row p-0 m-0 pt-3 px-lg-4 my-lg-4 my-xl-5">
			<div class="col-12 col-md-6 col-xl-4 offset-xl-2">
				<div data-aos="fade-up" data-aos-delay="300">
					<p class="p-0 m-0 pb-2 fuente-preguntas-titulo">1-¿Qué necesito para ser cliente?</p>
					<p class="fuente-preguntas-texto">
						Para ser cliente, coordinamos una visita con uno de nuestros agentes de venta para una atención personalizada. Puedes brindarnos tus datos en este
						<a @click="abreModal" class="difarmer-link">enlace</a>&nbsp;para que nuestro personal se comunique contigo.
					</p>
				</div>
			</div>
			<div class="col-12 col-md-6 col-xl-4">
				<div data-aos="fade-up" data-aos-delay="400">
					<p class="p-0 m-0 pb-2 fuente-preguntas-titulo">2-¿Cómo es la forma de operar?</p>
					<p
						class="fuente-preguntas-texto"
					>Operamos a través de agentes de venta y de nuestra plataforma en línea, siendo estos los medios por los cuales puedes realizar tu pedido. La entrega de sus productos puede ser por medio de nuestra ruta de distribución o directamente con tu agente de venta..</p>
				</div>
			</div>
			<div class="col-12 col-md-6 col-xl-4 offset-xl-2">
				<div data-aos="fade-up" data-aos-delay="500">
					<p class="p-0 m-0 pb-2 fuente-preguntas-titulo">3-¿Con qué cobertura cuenta Difarmer?</p>
					<p
						class="fuente-preguntas-texto"
					>Contamos con CEDIS en Culiacán, Torreón, León, Puebla, Querétaro y Mexicali. Atendemos en toda la República Mexicana.</p>
				</div>
			</div>
			<div class="col-12 col-md-6 col-xl-4">
				<div data-aos="fade-up" data-aos-delay="600">
					<p class="p-0 m-0 pb-2 fuente-preguntas-titulo">4-¿Puedo obtener un crédito?</p>
					<p class="pb-3 fuente-preguntas-texto">Sí, ofrecemos línea de crédito, sujeto a aprobación.</p>
				</div>
			</div>
			<div class="col-12 col-md-6 col-xl-4 offset-xl-2 mb-5">
				<div data-aos="fade-up" data-aos-delay="300">
					<p class="p-0 m-0 pb-2 fuente-preguntas-titulo">5-¿Cómo puedo pagar mi pedido?</p>
					<p
						class="fuente-preguntas-texto"
					>Puedes pagar por medio de nuestro sitio web, cheque, depósito bancario, transferencia electrónica, tarjeta de crédito/débito y en efectivo.</p>
				</div>
			</div>
		</div>
		<!-- Chat -->
		<div class="row p-0 m-0 py-3 py-sm-4 pt-lg-5 pb-lg-5 fondo-chat">
			<div
				class="col-10 offset-1 col-sm-8 offset-sm-2 col-md-7 offset-md-1 col-xl-5 offset-xl-2 d-flex align-items-center"
			>
				<div>
					<p class="fuente-chat-titulo text-md-right text-left text-lg-left">¿No encontraste respuesta?</p>
					<p
						class="fuente-chat-texto p-0 m-0 mt-2 mb-4 text-left text-md-right text-lg-left"
					>Contáctanos, ya sea por correo electrónico o por medio de nuestro chat en línea (disponible L-V: 9:00 – 19:00 y S: 9:00 – 14:00).</p>
					<div class="row" id="chat">
						<div class="col-12 text-left">
							<a class="link btn btn-block fuente-boton" href="https://bit.ly/39Lfp0n">Whatsapp</a>
							<br />
							<a @click="muestraChat" class="link btn btn-block fuente-boton">Chat en l&iacute;nea</a>
						</div>
					</div>
				</div>
			</div>
			<div
				class="col-8 offset-2 col-md-3 offset-md-0 col-xl-3 d-sm-flex justify-content-center align-items-center d-none"
			>
				<img class="img-fluid" src="@/assets/img-pub/Difarmer-contacto-2.png" />
			</div>
		</div>

		<!-- Pie pagina -->
		<pm-pie-pagina></pm-pie-pagina>
		<pm-modal-contacto :visible="mostrarModal" @close="mostrarModal = false" ></pm-modal-contacto>
	</div>
</template>


<script>
	import PmModalContacto from "@/components/publica/ModalContacto"
	import PmHeader from "@/components/publica/Header"
	import PmPiePagina from "@/components/publica/PiePagina"
	export default {
		head() {
			return {
				script: [
					{
						src:
							"https://bootstrap.smartsuppchat.com/bootstrap.php?key=c362ee8f546e8a253c66804bceb675051164e702",
						async: true,
						charset: "utf-8"
					}
				]
			}
		},
		data(){
			return {
				mostrarModal: false,
			}
		},
		components: {
			PmHeader,
			PmPiePagina,
			PmModalContacto
		},
		methods: {
			abreModal() {
				this.mostrarModal = true				
			},
			muestraChat() {
				let smartsupp = window.smartsupp
				smartsupp("chat:open")
				this.mostrarChat()
			}
		}
	}
</script>

<style scoped>
	.difarmer-link{
		color: #007bff;
		text-decoration: none;
		background-color: transparent;
		cursor: pointer;
	}
	/* Cabecera */
	.fondo-header {
		/* background-image: url(""); */
		background-repeat: no-repeat, repeat;
		background-size: cover;
		background-position: center;
	}
	.fuente-header-titulo {
		font-weight: 600;
		color: var(--color-blanco);
	}
	.fuente-header-subtitulo {
		color: var(--color-blanco);
	}
	/* Preguntas */
	.fuente-preguntas-titulo {
		font-weight: 600;
		font-style: italic;
		color: var(--color-amarillo);
	}
	.fuente-preguntas-texto {
		font-family: "Open Sans", sans-serif;
		color: var(--color-gris-dark);
	}
	/* Chat */
	.fondo-chat {
		background-color: #c2e4f6;
	}
	.fuente-chat-titulo {
		font-weight: 600;
		font-style: italic;
		color: var(--color-azul);
	}
	.fuente-chat-texto {
		font-family: "Open Sans", sans-serif;
		color: var(--color-azul);
	}
	.fuente-boton {
		font-family: "Open Sans", sans-serif;
		background-color: #c2e4f6 !important;
		border-color: var(--color-azul) !important;
		color: var(--color-azul) !important;
	}
	.fuente-boton:hover {
		background-color: var(--color-azul) !important;
		border-color: var(--color-azul) !important;
		color: var(--color-blanco) !important;
	}

	/* xs */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (max-width: 575px) {
		/* Cabecera */
		.fondo-header {
			background-image: url("../../assets/img-pub/Preguntas frecuentes 576px.png");
		}
		.fuente-header-titulo {
			font-size: 30px !important;
		}
		.fuente-header-subtitulo {
			font-size: 28px !important;
		}
		/* Preguntas */
		.fuente-preguntas-titulo {
			font-size: 20px !important;
		}
		.fuente-preguntas-texto {
			font-size: 14px !important;
		}
		/* Chat */
		.fuente-chat-titulo {
			font-size: 20px !important;
		}
		.fuente-chat-texto {
			font-size: 14px !important;
		}
		.fuente-boton {
			font-size: 16px !important;
		}
	}

	/* sm */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (min-width: 576px) and (max-width: 767px) {
		/* Cabecera */
		.fondo-header {
			background-image: url("../../assets/img-pub/Preguntas frecuentes 576px.png");
		}
		.fuente-header-titulo {
			font-size: 43px !important;
		}
		.fuente-header-subtitulo {
			font-size: 43px !important;
		}
		/* Preguntas */
		.fuente-preguntas-titulo {
			font-size: 20px !important;
		}
		.fuente-preguntas-texto {
			font-size: 16px !important;
		}
		/* Chat */
		.fuente-chat-titulo {
			font-size: 20px !important;
		}
		.fuente-chat-texto {
			font-size: 16px !important;
		}
		.fuente-boton {
			font-size: 16px !important;
		}
		/*  */
		.d-none {
			display: none !important;
		}
	}

	/* md */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 768px) and (max-width: 991px) {
		/* Cabecera */
		.fondo-header {
			background-image: url("../../assets/img-pub/Preguntas frecuentes 768px.png");
		}
		.fuente-header-titulo {
			font-size: 43px !important;
		}
		.fuente-header-subtitulo {
			font-size: 43px !important;
		}
		/* Preguntas */
		.fuente-preguntas-titulo {
			font-size: 20px !important;
		}
		.fuente-preguntas-texto {
			font-size: 16px !important;
		}
		/* Chat */
		.fuente-chat-titulo {
			font-size: 20px !important;
		}
		.fuente-chat-texto {
			font-size: 16px !important;
		}
		.fuente-boton {
			font-size: 16px !important;
		}
	}

	/* lg */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 992px) and (max-width: 1199px) {
		/* Cabecera */
		.fuente-header-titulo {
			font-size: 43px !important;
		}
		.fuente-header-subtitulo {
			font-size: 43px !important;
		}
		/* Preguntas */
		.fuente-preguntas-titulo {
			font-size: 28px !important;
		}
		.fuente-preguntas-texto {
			font-size: 18px !important;
		}
		/* Chat */
		.fuente-chat-titulo {
			font-size: 28px !important;
		}
		.fuente-chat-texto {
			font-size: 18px !important;
		}
		.fuente-boton {
			font-size: 18px !important;
		}
	}

	/* xl */
	/* Los estilos aqui contenidos solo se aplicaran a partir del tamaño de pantalla indicado */
	@media screen and (min-width: 1200px) {
		/* Cabecera */
		.fuente-header-titulo {
			font-size: 55px !important;
		}
		.fuente-header-subtitulo {
			font-size: 50px !important;
		}
		/* Preguntas */
		.fuente-preguntas-titulo {
			font-size: 32px !important;
		}
		.fuente-preguntas-texto {
			font-size: 20px !important;
		}
		/* Chat */
		.fuente-chat-titulo {
			font-size: 32px !important;
		}
		.fuente-chat-texto {
			font-size: 20px !important;
		}
		.fuente-boton {
			font-size: 20px !important;
		}
	}
</style>